import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import WelcomeScreen from './WelcomeScreen';

const Auth = ({ isModal = false, onLogin, onRegister, onWelcomeStateChange }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [newUser, setNewUser] = useState(null);
  const { login } = useAuth();

  const handleLogin = (user, token) => {
    if (isModal && onLogin) {
      onLogin(user, token);
    } else {
      login(user, token);
    }
  };

  const handleRegister = (user, token) => {
    setNewUser(user);
    setShowWelcome(true);
    if (onWelcomeStateChange) {
      onWelcomeStateChange(true);
    }
  };

  const handleLoginAfterRegister = () => {
    setShowWelcome(false);
    setNewUser(null);
    setIsLogin(true);
    if (onWelcomeStateChange) {
      onWelcomeStateChange(false);
    }
  };

  const switchToRegister = () => {
    setIsLogin(false);
    setShowForgotPassword(false);
    if (onWelcomeStateChange) {
      onWelcomeStateChange(false);
    }
  };

  const switchToLogin = () => {
    setIsLogin(true);
    setShowForgotPassword(false);
    if (onWelcomeStateChange) {
      onWelcomeStateChange(false);
    }
  };

  const showForgotPasswordForm = () => {
    setShowForgotPassword(true);
    if (onWelcomeStateChange) {
      onWelcomeStateChange(false);
    }
  };

  const backToLogin = () => {
    setShowForgotPassword(false);
    if (onWelcomeStateChange) {
      onWelcomeStateChange(false);
    }
  };

  if (showWelcome && newUser) {
    if (isModal) {
      // Show a simple welcome message in the modal
      return (
        <div className="welcome-modal">
          <div className="welcome-modal-content">
            <h2>Welcome, {newUser.username}!</h2>
            <p>Your account has been created successfully!</p>
            <p>Please log in to start building your decks.</p>
            <button 
              className="login-button"
              onClick={handleLoginAfterRegister}
            >
              Login
            </button>
          </div>
        </div>
      );
    }
    return <WelcomeScreen username={newUser.username} onLogin={handleLoginAfterRegister} />;
  }

  if (showForgotPassword) {
    return <ForgotPassword onBackToLogin={backToLogin} />;
  }

  // If in modal mode, don't wrap in full-screen container
  if (isModal) {
    return (
      <>
        {isLogin ? (
          <Login 
            onLogin={handleLogin}
            onSwitchToRegister={switchToRegister}
            onForgotPassword={showForgotPasswordForm}
          />
        ) : (
          <Register 
            onRegister={handleRegister}
            onSwitchToLogin={switchToLogin}
          />
        )}
      </>
    );
  }

  // Full-screen mode (original behavior)
  return (
    <>
      {isLogin ? (
        <Login 
          onLogin={handleLogin}
          onSwitchToRegister={switchToRegister}
          onForgotPassword={showForgotPasswordForm}
        />
      ) : (
        <Register 
          onRegister={handleRegister}
          onSwitchToLogin={switchToLogin}
        />
      )}
    </>
  );
};

export default Auth; 